import {
  ColumnType,
  ExpectedRowTypes,
  PatientDetailType,
  TestKitsListType,
  TestKitType,
  UserType,
} from "@/common/types";
import KpiCard from "@/components/kpiCard";
import { getPatientDetailById } from "@/redux/actions/usersActions";
import { RootState } from "@/redux/reducers";
import Table from "@/components/table";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTestsKits } from "@/redux/actions/testKitActions";
import { capitalize, transformKitStatus } from "@/utils/common.util";
import { useNavigate } from "react-router-dom";
import CardsForTable from "@/components/cards-for-table";

const columns: ColumnType[] = [
  {
    field: "kit_id",
    headerName: "Kit ID",
  },
  {
    field: "assigned_patient",
    headerName: "Patient",
    render: (row) => (row as TestKitType).assigned_patient?.name || "-",
  },
  {
    field: "status",
    headerName: "Status",
    render: (row) => transformKitStatus((row as TestKitType).status),
  },
];

const PatientsView = ({ user }: { user: UserType }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { patientDetails } = useSelector((state: RootState) => state.users);
  const { testKits } = useSelector((state: RootState) => state.testKit);

  useEffect(() => {
    dispatch(getPatientDetailById(user?.id as number));
    dispatch(getTestsKits(1, { patient: `${user?.id}` }, 5));
  }, [dispatch, user.id]);

  const handleRowClick = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    row: ExpectedRowTypes
  ) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/test/${row.id}`);
  };

  return (
    <div>
      <div className="text-3xl font-bold">{user.name}</div>
      <div className="text-gray-400 text-xs">({capitalize(user.role)})</div>
      <div className="text-gray-400 text-xs">{user.email}</div>
      <div className="flex gap-4 mt-4">
        <KpiCard
          label="Assigned Doctor"
          value={(patientDetails as PatientDetailType)?.associated_doctor?.name}
        />
      </div>
      <div className="mt-8 md:mt-4">
        <div className="text-black font-semibold text-base mb-2">
          Test Kit History
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex">
          <Table
            rows={(testKits as TestKitsListType)?.results.slice(0, 5) || []}
            columns={columns}
            rowsPerPage={5}
            onRowClick={(e, row) =>
              handleRowClick(
                e as React.MouseEvent<HTMLTableRowElement, MouseEvent>,
                row
              )
            }
          />
        </div>

        {/* Mobile View */}
        <div className="flex md:hidden">
          <CardsForTable
            rows={(testKits as TestKitsListType)?.results || []}
            columns={columns}
            rowsPerPage={5}
            onRowClick={(e, row) =>
              handleRowClick(
                e as React.MouseEvent<HTMLTableRowElement, MouseEvent>,
                row
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default PatientsView;
